import { jsx as e, jsxs as r } from "react/jsx-runtime";
import { Dialog as s } from "@base-ui/react/dialog";
import { cn as o } from "../../lib/utils.js";
import { Button as l } from "./button.js";
import { XIcon as m } from "lucide-react";
function y({ ...t }) {
  return /* @__PURE__ */ e(s.Root, { "data-slot": "sheet", ...t });
}
function b({ ...t }) {
  return /* @__PURE__ */ e(s.Trigger, { "data-slot": "sheet-trigger", ...t });
}
function S({ ...t }) {
  return /* @__PURE__ */ e(s.Close, { "data-slot": "sheet-close", ...t });
}
function c({ ...t }) {
  return /* @__PURE__ */ e(s.Portal, { "data-slot": "sheet-portal", ...t });
}
function h({ className: t, ...a }) {
  return /* @__PURE__ */ e(
    s.Backdrop,
    {
      "data-slot": "sheet-overlay",
      className: o(
        "fixed inset-0 z-50 bg-black/10 transition-opacity duration-150 data-ending-style:opacity-0 data-starting-style:opacity-0 supports-backdrop-filter:backdrop-blur-xs",
        t
      ),
      ...a
    }
  );
}
function N({
  className: t,
  children: a,
  side: d = "right",
  showCloseButton: i = !0,
  ...n
}) {
  return /* @__PURE__ */ r(c, { children: [
    /* @__PURE__ */ e(h, {}),
    /* @__PURE__ */ r(
      s.Popup,
      {
        "data-slot": "sheet-content",
        "data-side": d,
        className: o(
          "fixed z-50 flex flex-col gap-4 bg-popover bg-clip-padding text-sm text-popover-foreground shadow-lg transition duration-200 ease-in-out data-ending-style:opacity-0 data-starting-style:opacity-0 data-[side=bottom]:inset-x-0 data-[side=bottom]:bottom-0 data-[side=bottom]:h-auto data-[side=bottom]:border-t data-[side=bottom]:data-ending-style:translate-y-[2.5rem] data-[side=bottom]:data-starting-style:translate-y-[2.5rem] data-[side=left]:inset-y-0 data-[side=left]:left-0 data-[side=left]:h-full data-[side=left]:w-3/4 data-[side=left]:border-r data-[side=left]:data-ending-style:translate-x-[-2.5rem] data-[side=left]:data-starting-style:translate-x-[-2.5rem] data-[side=right]:inset-y-0 data-[side=right]:right-0 data-[side=right]:h-full data-[side=right]:w-3/4 data-[side=right]:border-l data-[side=right]:data-ending-style:translate-x-[2.5rem] data-[side=right]:data-starting-style:translate-x-[2.5rem] data-[side=top]:inset-x-0 data-[side=top]:top-0 data-[side=top]:h-auto data-[side=top]:border-b data-[side=top]:data-ending-style:translate-y-[-2.5rem] data-[side=top]:data-starting-style:translate-y-[-2.5rem] data-[side=left]:sm:max-w-sm data-[side=right]:sm:max-w-sm",
          t
        ),
        ...n,
        children: [
          a,
          i && /* @__PURE__ */ r(
            s.Close,
            {
              "data-slot": "sheet-close",
              render: /* @__PURE__ */ e(
                l,
                {
                  variant: "ghost",
                  className: "absolute top-3 right-3",
                  size: "icon-sm"
                }
              ),
              children: [
                /* @__PURE__ */ e(
                  m,
                  {}
                ),
                /* @__PURE__ */ e("span", { className: "sr-only", children: "Close" })
              ]
            }
          )
        ]
      }
    )
  ] });
}
function v({ className: t, ...a }) {
  return /* @__PURE__ */ e(
    "div",
    {
      "data-slot": "sheet-header",
      className: o("flex flex-col gap-0.5 p-4", t),
      ...a
    }
  );
}
function w({ className: t, ...a }) {
  return /* @__PURE__ */ e(
    "div",
    {
      "data-slot": "sheet-footer",
      className: o("mt-auto flex flex-col gap-2 p-4", t),
      ...a
    }
  );
}
function C({ className: t, ...a }) {
  return /* @__PURE__ */ e(
    s.Title,
    {
      "data-slot": "sheet-title",
      className: o(
        "font-heading text-base font-medium text-foreground",
        t
      ),
      ...a
    }
  );
}
function k({
  className: t,
  ...a
}) {
  return /* @__PURE__ */ e(
    s.Description,
    {
      "data-slot": "sheet-description",
      className: o("text-sm text-muted-foreground", t),
      ...a
    }
  );
}
export {
  y as Sheet,
  S as SheetClose,
  N as SheetContent,
  k as SheetDescription,
  w as SheetFooter,
  v as SheetHeader,
  C as SheetTitle,
  b as SheetTrigger
};
//# sourceMappingURL=sheet.js.map
